import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideo from '@/components/UI/EFVideo';

export default function A() {
    const { useEffect, useRef } = useGlobal();
    const refV1 = useRef(null);

    let controller: any;
    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    let pageYOffset = 0;
    const onScroll = (e: any) => {
        const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;
        // 仅当页面从上往下回退入视窗， 且进入一半时视频重新播放
        if (pageYOffset > window?.pageYOffset && window?.pageYOffset <= layoutH / 2) {
            refV1?.current?.play();
        }
        pageYOffset = window?.pageYOffset;
    };

    useEffect(() => {
        window.addEventListener('scroll', onScroll);
    }, []);

    return (
        <div className={`xstream_A ${css.xstream_A}`}>
            <div className="section-1">
                <div className="video-wrapper video1">
                    <EFVideo ref={refV1} sources={['/media/x-stream/pc/01.webm', '/media/x-stream/pc/01.mp4']} loop={false} />
                    <div className="after"></div>
                </div>
                <div className="gap"></div>
            </div>
        </div>
    );
}
